import clsx from 'clsx';

/**
 * Das Titelbild des Spiels.
 *
 * Zwei bewusste Entscheidungen:
 *  - `<picture>` mit WebP und JPEG-Rückfall: Das Ausgangsbild ist ein PNG mit
 *    2,3 MB, was für eine Startseite zu schwer wäre. Die WebP-Fassung liegt bei
 *    rund 260 kB bei praktisch gleichem Eindruck.
 *  - `object-contain` statt `object-cover`: Das Bild trägt Logo und Titel bereits
 *    in sich. Ein Beschnitt würde genau diese Bildmitte anschneiden.
 */
export function HeroImage({
  className,
  pictureClassName,
  priority,
}: {
  className?: string;
  /**
   * Klassen für das umschließende `<picture>`.
   *
   * Nötig, wenn das Bild absolut positioniert werden soll: Das `<picture>` ist
   * dann das Element, das den Bezugsrahmen füllen muss – das `<img>` allein
   * hinge sonst am nächsten positionierten Vorfahren weiter oben.
   */
  pictureClassName?: string;
  priority?: boolean;
}) {
  return (
    <picture className={pictureClassName}>
      <source srcSet="/hosting-simulator-hero.webp" type="image/webp" />
      <img
        src="/hosting-simulator-hero.jpg"
        alt="Hosting Company Simulator – Dashboard, Netzkarte und BGP-Routingtabelle im Rechenzentrum"
        width={1536}
        height={1024}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        className={clsx('object-contain', className)}
      />
    </picture>
  );
}
